import { gql } from '@apollo/client';

export const CREATE_TEAM = gql`
  mutation CreateTeam($input: NewTeam!) {
    createTeam(input: $input) {
      id
      name
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

export const UPDATE_TEAM_RELATIONSHIP = gql`
  mutation UpdateTeamRelationship($input: TeamRelations!) {
    updateTeamRelationship(input: $input) {
      id
      name
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation UpdateTeam($input: UpdateTeam!) {
    updateTeam(input: $input) {
      id
      name
      concessionIDs
      roadIDs
      userIDs
      vehicleIDs
    }
  }
`;

export const DELETE_TEAM = gql`
  mutation DeleteTeam($id: ID!) {
    deleteTeam(id: $id)
  }
`;
